import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "row"]

  connect() {
    // optional: console log to confirm controller loaded
    // console.log("Permissions controller connected")
  }

  search() {
    const filter = this.searchTarget.value.toLowerCase()
    this.rowTargets.forEach(row => {
      const permissionName = row.dataset.permissionName.toLowerCase()
      row.style.display = permissionName.includes(filter) ? "" : "none"
    })
  }
}
